export default [
  {
    path: '/updating-system',
    name: 'update-system',
    component: () => import('@/modules/erros/views/pages/UpdatingSystem.vue'),
    meta: {
      title: 'Sistema atualizando',
    },
  },
  {
    path: '/not-found',
    name: 'not-found',
    component: () => import('@/modules/erros/views/pages/NotFound.vue'),
    meta: {
      title: 'Não encontrado',
    },
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import('@/modules/erros/views/pages/Maintenance.vue'),
    meta: {
      title: 'Manutenção',
    },
  },
  {
    path: '/expired-session',
    name: 'expired-session',
    component: () => import('@/modules/erros/views/pages/ExpiredSession.vue'),
    meta: {
      title: 'Sessão expirada',
      allowOnlyMercapromo: true,
    },
  },
  {
    path: '/someting-wrong',
    name: 'something-wrong',
    component: () => import('@/modules/erros/views/pages/SomethingWrong.vue'),
    meta: {
      title: 'Erro desconhecido',
    },
  },
  {
    path: '/restrict-access',
    name: 'restrict-access',
    component: () => import('@/modules/erros/views/pages/RestrictAccess.vue'),
    meta: {
      title: 'Área restrita',
    },
  },
]
